export default "__VITE_ASSET__Bp5Bf_6y__"